import { Fragment, type ReactElement } from "react"

import isEmpty from "lodash-es/isEmpty"

import {
    ESpecialChar,
    ETypographyColor,
    ETypographySize,
    ETypographyTag,
    ETypographyWeight,
    type ISelectOption,
    SpecialChars,
    Typography
} from "@/3514/components"

import config from "./select.config"

function renderLabel(params: { label: string }): ReactElement {
    return (
        !isEmpty(params.label) && (
            <Typography
                size={ETypographySize.Small}
                weight={ETypographyWeight.Bold}
                text={
                    <Fragment>
                        {params.label}
                        {SpecialChars[ESpecialChar.Colon]}
                    </Fragment>
                }
            />
        )
    )
}

function renderOption(params: {
    option: ISelectOption
    isCurrent: boolean
    isError: boolean
    isItalic: boolean
}): ReactElement {
    return (
        <Typography
            text={params.option.label}
            className={config.baseClasses.optionText({
                isError: params.isError,
                isDisabled: params.option.isDisabled
            })}
            isItalic={params.isError || params.isItalic}
            weight={params.isCurrent && !params.option.isDisabled ? ETypographyWeight.Bold : ETypographyWeight.Default}
            color={((): ETypographyColor => {
                if (params.option.isDisabled) return ETypographyColor.Black
                if (params.isCurrent && !params.option.isDisabled) return ETypographyColor.Blue200
                if (params.isError) return ETypographyColor.Gray23

                return ETypographyColor.Black
            })()}
            size={ETypographySize.Small}
            tag={ETypographyTag.Paragraph}
        />
    )
}

export default { renderLabel, renderOption }
